import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from "react-router-dom"

import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import { applyMiddleware, compose, createStore } from "redux"
import thunk from 'redux-thunk';
import { Provider } from "react-redux"
import { getFirebase, ReactReduxFirebaseProvider } from "react-redux-firebase"
import { createFirestoreInstance } from "redux-firestore"
import { rootReducer } from "./Store/reducers"

import './index.css'
import 'semantic-ui-css/semantic.min.css'

import App from './App'
import ReactGA from "react-ga4";



// Get Firebase config from env
const config = {
  apiKey: "AIzaSyBjsxVF5EDZ4C2uL7xjFr68mP4cC2AehSQ",
authDomain: "yaale-2.firebaseapp.com",
databaseURL: "https://yaale-2.firebaseio.com",
projectId: "yaale-2",
storageBucket: "yaale-2.appspot.com",
messagingSenderId: "1052754602346",
appId: "1:1052754602346:web:50af5d653ca52f663a9d13",
measurementId: "G-FRY58K0LEJ"
}
const rrfConfig = {
}

firebase.initializeApp(config)
firebase.firestore()

const initialState = {}

// const middlewares = [
//   thunk.withExtraArgument(getFirebase)
// ]

const store = createStore(
  rootReducer,
  initialState,
  // compose(
  //   applyMiddleware(...middlewares)
  // )
)

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance, // since we are using Firestore
}

ReactGA.initialize("G-FRY58K0LEJ");

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById('root')
)
